import { apiClient } from './client';

export interface SampleDataArea {
  key: string;
  name: string;
  description: string;
  order: number;
  dependsOn: string[];
  scenarioCount: number;
}

export interface SampleAreaPlan {
  key: string;
  name: string;
  existingCount: number;
  plannedCount: number;
  alreadySeeded: boolean;
  notes: string[];
}

export interface SampleDataPlan {
  companyCode: string;
  areas: SampleAreaPlan[];
  issues: string[];
  totalPlanned: number;
}

export interface SampleAreaResult {
  key: string;
  name: string;
  status: 'OK' | 'SKIPPED' | 'FAILED';
  created: number;
  skipped: number;
  messages: string[];
  errors: string[];
}

export interface SampleDataResult {
  companyCode: string;
  status: 'COMPLETED' | 'PARTIAL' | 'FAILED';
  areas: SampleAreaResult[];
  issues: string[];
  totalCreated: number;
  totalSkipped: number;
  duration: string;
}

/** One demonstrable situation: what it shows, what goes in, and what the ledger should do about it. */
export interface SampleScenario {
  key: string;
  area: string;
  screen: string;
  title: string;
  whatItShows: string;
  inputs: string[];
  expectedOutput: string;
}

export const sampleDataApi = {
  async areas(): Promise<SampleDataArea[]> {
    const r = await apiClient.get('/system/sample-data/areas');
    return r.data?.data ?? [];
  },
  async catalogue(): Promise<SampleScenario[]> {
    const r = await apiClient.get('/system/sample-data/catalogue');
    return r.data?.data ?? [];
  },
  async preview(areaKeys: string[]): Promise<SampleDataPlan> {
    const r = await apiClient.post('/system/sample-data/preview', { areaKeys });
    return r.data?.data;
  },
  async generate(areaKeys: string[], confirmation: string): Promise<SampleDataResult> {
    const r = await apiClient.post('/system/sample-data/generate', { areaKeys, confirmation });
    return r.data?.data;
  },
};
